export const VIDFLEET_VIDEO_START_STREAMING = "VIDFLEET_VIDEO_START_STREAMING";
export const VIDFLEET_VIDEO_START_STREAMING_RESPONSE = "VIDFLEET_VIDEO_START_STREAMING_RESPONSE";
export const VIDFLEET_VIDEO_STOP_STREAMING = "VIDFLEET_VIDEO_STOP_STREAMING";
export const VIDFLEET_VIDEO_STOP_STREAMING_RESPONSE = "VIDFLEET_VIDEO_STOP_STREAMING_RESPONSE";
export const VIDFLEET_VIDEO_GET_STREAMING_STATUS = "VIDFLEET_VIDEO_GET_STREAMING_STATUS";
export const VIDFLEET_VIDEO_GET_STREAMING_STATUS_RESPONSE = "VIDFLEET_VIDEO_GET_STREAMING_STATUS_RESPONSE";
export const VIDFLEET_VIDEO_GET_CLIP_BY_ID = "VIDFLEET_VIDEO_GET_CLIP_BY_ID";
export const VIDFLEET_VIDEO_GET_CLIP_BY_ID_RESPONSE = "VIDFLEET_VIDEO_GET_CLIP_BY_ID_RESPONSE";
export const VIDFLEET_VIDEO_GET_PICTURE_BY_ID = "VIDFLEET_VIDEO_GET_PICTURE_BY_ID";
export const VIDFLEET_VIDEO_GET_PICTURE_BY_ID_RESPONSE = "VIDFLEET_VIDEO_GET_PICTURE_BY_ID_RESPONSE";
export const VIDFLEET_VIDEO_GET_ONLINE_STATUS = "VIDFLEET_VIDEO_GET_ONLINE_STATUS";
export const VIDFLEET_VIDEO_GET_ONLINE_STATUS_RESPONSE = "VIDFLEET_VIDEO_GET_ONLINE_STATUS_RESPONSE";
export const VIDFLEET_VIDEO_MODAL_SHOW = "VIDFLEET_VIDEO_MODAL_SHOW";
export const VIDFLEET_VIDEO_MODAL_HIDE = "VIDFLEET_VIDEO_MODAL_HIDE";


export const VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST = "VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST";
export const VIDFLEET_VIDEO_GET_CLIP_REQUEST_RESULT = "VIDFLEET_VIDEO_GET_CLIP_REQUEST_RESULT";

